import styled from 'styled-components'
import { Grid } from '@material-ui/core'

export const Container = styled.div`
  width: 100%;

  min-height: 100vh;
  background: #fafafa;
`

export const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 20px 40px;
`

export const Title = styled.h1`
  font-size: 2.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 30px;
`

export const GridContainer = styled(Grid)`
  width: 100%;
  display: flex;
  gap: 20px;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`

export const LeftSection = styled.div`
  width: 280px;
  min-width: 280px;

  @media (max-width: 960px) {
    width: 100%;
  }
`

export const RightSection = styled.div`
  flex: 1;
`

export const CardContainer = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;
`

export const SectionTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 20px;
`

export const DashboardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

export const PeriodSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  button {
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  span {
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.gray80};
    min-width: 80px;
    text-align: center;
  }
`

export const PatientsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PatientCard = styled.button`
  width: 100%;
  background: #f8f8fa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f0f0f5;
  }

  .name {
    font-size: 1.5rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.black};
  }

  .time {
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.gray80};
  }
`

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

export const MetricCard = styled.div<{ highlighted?: boolean }>`
  background: ${({ highlighted }) => (highlighted ? '#FFECF0' : '#f8f8fa')};
  border-radius: 10px;
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid
    ${({ highlighted }) => (highlighted ? '#ffccd5' : '#f0f0f0')};

  .info {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .label {
      font-size: 1.4rem;
      color: ${({ theme }) => theme.colors.black};
      font-weight: 400;
    }

    .value {
      font-size: 1.6rem;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.black};
    }
  }

  .icon-wrapper {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #e4dafc;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 20px;
      height: 20px;
    }
  }
`

export const EmptyState = styled.div`
  padding: 20px;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray80};
  font-size: 1.4rem;
`
